export const formsEn = {
  administrator: {
    title: {
      create: 'Create Administrator',
      edit:'Edit: ',
    },
    label: {
      name: 'Name',
      email: 'E-mail',
      password: 'Password',
      repeatpassword: 'Repeat password',
      phone: 'Phone',
      rol: 'Rol',
      bookmaker: 'Bookmaker',
    },
    buttons: {
      create: 'Create',
      edit: 'Edit',
    }
  },
  competition: {
    title: {
      create: 'Create Competition',
      edit:'Edit: ',
    },
    label: {
      name: 'Name',
      country: 'Country',
      countryCode: 'Country code',
      provider: 'Provider',
      providerId: 'Provider Id',
      sport: 'Sport',
      providerSeason: 'Season',
    },
    buttons: {
      create: 'Create',
      edit: 'Edit',
    }
  },
  contest:{
    title: {
      create: 'Create Contest',
      edit: 'Edit Contest',
    },
    form: {
      name: 'Name',
      competition: 'Competition',
      matchset: 'Matchset',
      status: 'Status',
      multiplier: 'Multiplier',
      minpot: 'Min pot',
      budget: 'Budget',
      maxentries: 'Max entries',
      entriesuser: 'User entries',
      pooltype: 'Pool Type',
      payout: 'Distribution of prizes',
      category: 'Category',
      format: 'Format',
      network: 'Network',
      currency: 'Currency',
      startdate: {
        date: 'Start date',
        time: 'Start time'
      },
      enddate: {
        date: 'End date',
        time: 'End time'
      },
      dateInfo: 'The dates can be modified when the status\' contest is "pending", "new", "open".',
    },
    buttons: {
      create: 'Create',
      edit: 'Edit',
    }
  },
  game: {
    title: {
      create: 'Create Game',
      edit: 'Edit: ',
    },
    label: {
      name: 'Name',
      alias: 'Alias',
      provider:'Provider',
      type:'Type',
      image:'Image',
      license:'License',
      jurisdictions:'Jurisdictions',
      launchdate: 'Launch date',
      teoricRTP: 'RTP Teórico',
      freespins: 'Admite Freespins',
      fun: 'Fun',
      volatility: 'Volatility',
      jackpot: 'Jackpot',
      bet: {
        title: 'Bet',
        default: 'Default',
        min: 'Min',
        max: 'Max',
        highest: 'Highest',
        mwm: 'Max win multiplier',
      },
      extrafields: 'Configuration parameters',
    },
    multicreate:{
      title:'Multicreate Game',
      fileInput:'Select file',
      helpText:'Please select a provider and upload the csv file with the list of games for bulk upload.',
      loadedGamesText:'Will insert a total of',
      game:'games'
    },
    confirmationDialog: {
      status: {
        title: 'Confirm',
        description: 'Are you sure about the massive game load?',
        okText: 'Confirm',
        cancelText: 'Cancel',
      },
    },
    buttons: {
      create: 'Create',
      edit: 'Edit',
    }
  },
  matchsets:{
    title: {
      create: 'Create Matchset',
      edit: 'Edit Matchset: ',
    },
    steps: {
      step1: 'Select matchset type',
      step2: 'Create matchset',
      step3: 'Resume'
    },
    match: 'Create Match',
    rounds: 'Create Round',
    day: 'Create Day',
    form: {
      matchsetType: 'Matchset Type',
      name: 'Name',
      matches: 'Matches',
      matchesInfo: 'You need to select competition to select matches',
      competition: 'Competitions',
      matchday: 'Match day',
      date: 'Date',
      dateInfo: 'All fields can be modified when the status\' matchset is "pending" or "new".',
      startdate: {
        date: 'Start date',
        time: 'Start time'
      },
      enddate: {
        date: 'End date',
        time: 'End time'
      },
    },
    resume: 'Resume',
    buttons: {
      next: 'Continue',
      cancel: 'Cancel',
      create: 'Create',
      edit: 'Edit'
    }
  },
  network: {
    title: {
      create: 'Create Network',
      edit: 'Edit: ',
    },
    memberInfo: 'Only it\'s posible add members.',
    steps: {
      step1: 'Select Jurisdiction',
      step2: 'Create Network',
      step3: 'Resume'
    },
    label: {
      name: 'Name',
      fee: 'Fee',
      organizer: 'Organizer',
      members: 'Members',
      jurisdiction: 'Jurisdiction',
    },
    buttons: {
      create: 'Create',
      edit: 'Edit',
      next: 'Next',
      update: 'Update'
    }
  },
  operator: {
    title: {
      create: 'Create Operator',
      edit:'Edit: ',
    },
    label: {
      name: 'Name',
      id: 'Code Id',
      fantasyenabled: 'Enabled',
      competition: 'Competition',
      connector: 'Connector',
      connectorId: 'Connector Id',
      connectorKey: 'Connector Key',
      key: 'Key',
      casinoApi: 'CasinoApi',
      sportsApi: 'SportsApi',
      bonusApi: 'BonusApi',
      lobbyURL: 'Lobby URL',
      cashier: 'Cashier URL',
      virtualsports: 'Virtualsports URL',
      sportsbook: 'Sportsbook URL',
      jurisdiction: 'Jurisdiction',
      accountManager: 'Account Manager',
      invoice: {
        name: 'Name',
        address: 'Address',
        vat: 'VAT number',
        tax: 'Tax',
        phone: 'Phone',
        email: 'Email',
      },
      config: {
        title: 'Configuration',
        cl: 'Competition Labs',
        oi: 'Opt-In',
        retail: 'Retail',
        raf: 'Refer a friend',
        rafpercen: 'Percentage',
      },
      sms: {
        title: 'SMS',
        origin: 'Origin',
        enabled: 'Enabled',
        user: 'User',
        password: 'Password',
      },
    },
    buttons: {
      create: 'Create',
      edit: 'Edit',
    }
  },
  provider: {
    title: {
      create: 'Create Provider',
      edit: 'Edit: ',
    },
    label: {
      name: 'Name',
      code: 'Code',
      accountManager:'Account Manager',
      fun: 'Fun',
      real: 'Real',
      mobile: 'Mobile',
      desktop: 'Desktop',
      urls: {
        launcher: 'Launcher',
        bonusAward: 'BonusAward',
        bonusCancel: 'BonusCancel',
        ping: 'Ping',
        roundDetails: 'RoundDetails',
        fixedLauncher: 'FixedLauncher',
        baseUrl: 'BaseUrl',
        gameList: 'GameList',
      },
      ggr: 'GGR',
      icon: 'Icon',
      image: 'Image',
      invoice: {
        name: 'Name',
        address: 'Address',
        vat: 'VAT number',
        tax: 'Tax',
        phone: 'Phone',
        email: 'Email',
      },
      config: {
        title: 'Configuration',
        rst: 'Return same transaction',
        amb: 'Allow multiple bets',
        rnc: 'Rollback no close',
        anr: 'Allow no round',
        aoc: 'Allow on closed',
        hfr: 'Have free rounds',
      },
      selection: 'Selection',
      singleGame: 'Mono Game',
      multiGame: 'Multi Game',
      singleUser: 'Mono User',
      multiUser: 'Multi User',
      customfields: 'Freerounds Form',
      extrafields: 'Configuration parameters',
      extrafieldsHidden: 'URL parameters',
    },
    buttons: {
      create: 'Create',
      edit: 'Edit',
    }
  },
  operatorProvider: {
    title: {
      operator: 'Operator: ',
      provider: ', Provider: ',
      create: ', Create Provider',
      edit: 'Edit: ',
    },
    label: {
      provider: 'Provider',
      key1: 'Key',
      key2: 'Secondary Key',
      key3: 'Terciary Key',
      ggr: 'GGR',
      cap: 'Bonus cap',
      urls: {
        launcher: 'Launcher',
        bonusAward: 'BonusAward',
        bonusCancel: 'BonusCancel',
        ping: 'Ping',
        roundDetails: 'RoundDetails',
        fixedLauncher: 'FixedLauncher',
        baseUrl: 'BaseUrl',
        gameList: 'GameList',
      },
      extrafields: 'Configuration parameters',
      extrafieldsHidden: 'URL parameters',
      cl: {
        title: 'Competition Labs',
        f: 'feed',
        w: 'widget',
      },
    },
    button:{
      details: 'See details',
      openadd: 'Add new provider',
      add: 'Add',
      edit: 'Edit',
    },
  },
  category: {
    title: {
      create: 'Create Category',
      edit: 'Edit: ',
    },
    label: {
      name: 'Name',
      country: 'Country',
      countryCode: 'CountryCode',
      provider: 'Provider',
      futmondo: 'Futmondo',
      sport: 'Sport',
      enabled: 'Enabled',
    },
    table: {
      title: 'Add levels',
      level: 'Level',
      name: 'Name',
      points: 'Points',
      rolldown: 'Roll Down',
      percentage: 'Percentage',
    },
    button: {
      create: 'Create',
      edit: 'Edit',
    }
  },
  invoice: {
    title: {
      create: 'Create Invoice',
    },
    provider: 'Provider',
    operator: 'Operator',
    customer: 'Customer',
    selectClient: 'Select Invoice Client',
    nextButton: 'Next',
    form: {
      invoiceID: 'Invoice Nº',
      invoiceDetails: 'Invoice details',
      items: 'Items',
      invoiceNotes: 'Invoice notes',
      invoiceDate: 'Invoice Date',
      invoiceDue: 'Due Date',
      invoiceAmountDue: 'Amount Due',
      paymentDetails: 'Payment details',
      paymentMethod: 'Payment Method: Bank transfer',
      paymentExpiration: 'Expiration: Cash',
      paymentAccountNumber: 'Account number',
      paymentAdvice: 'Reverse charge (-art.6.1.M) of the R.D.1619/2012, 30 November',
      generateInvoice: 'Generate Invoice',
      viewInvoiceTitle: 'View Invoice',
      invoice: 'Invoice',
      downloadInvoice: 'Download Invoice',
      discount: 'Discount',
      tax: 'Tax',
    },
    label: {
      no: 'No.',
      description: 'Description',
      qty: 'Qty',
      price: 'Price',
      discount: 'Discount %',
      tax: 'Tax %',
      total: 'Total',
    },
  },
  freespins: {
    title: {
      create: 'Create Freespins',
      edit: 'Edit: ',
    },
    steps: {
      title1: 'Step 1',
      title2: 'Step 2, Type and games',
      title3: 'Step 3, Users',
    },
    label: {
      name: 'Name',
      id: 'Id',
      daterange: 'Dates',
      type: 'Type',
      rounds: 'Rounds',
      games: 'Games',
      operator: 'Operator',
      users: 'Users',
      selection: 'Selection',
      manual: 'Manual',
      all: 'All',
    },
    button: {
      next: 'Next',
      send: 'Send',
    },
  },
  lobby: {
    title: {
      create: 'Create Lobby',
      edit: 'Edit: ',
    },
    label: {
      operator: 'Operator',
      providers: 'Providers',
      banner: {
        bannersTitle: 'Banner',
        title: 'Title',
        description: 'Description',
        imageDesktop: 'Image Desktop',
        imageMobile: 'Image Mobile',
        url: 'URL',
      },
      new: 'New',
      category: 'Category',
      name: 'Name',
      names: 'Name',
      nameslabel: 'Name',
      icon: 'Icon',
      img: 'Image',
      games: 'Games',
      gamesimg: 'Image',
      extra: {
        isNew: 'IsNew',
        featured: 'Featured',
        hot: 'Hot',
      },
    },
    button: {
      create: 'Create',
      edit: 'Edit',
      addCategory: 'Add new category',
      addBanner: 'Add new banner',
    }
  },
  freerounds: {
    title: {
      create: 'Create Freerounds',
      edit: 'Edit: ',
    },
    label: {
      externalId: 'External Id',
      daterange: 'Dates',
      amount: 'Amount',
      games: 'Games',
      operator: 'Operator',
      provider: 'Provider',
      users: 'Users',
      extrafields: 'Configuration parameters',
      extrafieldsHidden: 'Parámetros de URL',
      selection: 'Selection',
      manual: 'Manual',
      all: 'All',
    },
    button: {
      send: 'Send',
    },
  },
  providerIpList: {
    title: {
      main: 'Provider\'s IP\'s',
      add:'Add new IP',
    },
    empty: 'No ip\'s added',
    button: {
      create: 'Create',
    }
  },
  operatorIpList: {
    title: {
      main: 'Operator\'s IP\'s',
      add:'Add new IP',
    },
    empty: 'No ip\'s added',
    button: {
      create: 'Create',
    }
  },
};